var map = {
	"./Auth.vue": [
		"2fef",
		"chunk-289aa23e"
	],
	"./Catalog.vue": [
		"247d",
		"chunk-72dfa128"
	],
	"./Landing.vue": [
		"bede",
		"chunk-4163b7c0"
	],
	"./Order.vue": [
		"cf2a",
		"chunk-3490afe2"
	],
	"./Prototype.vue": [
		"ffac",
		"chunk-2d2389d8"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;